<app-header></app-header>
<app-sidebar [pendingCount]="pendingCount"></app-sidebar>
<app-right-sidebar></app-right-sidebar>
<div [dir]="direction">
  <router-outlet></router-outlet>
</div>
